<!--  发票行 -->
<template>
  <div>
    <!--新增/删除按钮-->
    <!--<vxe-toolbar>
       <template v-slot:buttons>
        <vxe-button
          v-if="canEdit"
          size="medium"
          type="primary"
          class="vxe-btn-primary"
          @click="handleMatching()"
        >
          {{ $t('addInvoice.invoiceLine.btns.matching') }}
        </vxe-button>
        <vxe-button
          v-if="canEdit"
          size="medium"
          type="primary"
          class="vxe-btn-primary"
          @click="insertEvent()"
        >
          {{ $t('addInvoice.invoiceLine.btns.add') }}
        </vxe-button>
        <vxe-button
          v-if="canEdit"
          size="medium"
          type="primary"
          class="vxe-btn-delete"
          icon="el-icon-delete"
          @click="deleteEvent()"
        >
          {{ $t('addInvoice.invoiceLine.btns.delete') }}
        </vxe-button>
        <vxe-button
          @click="handleSettleBatch()"
          type="primary"
          size="medium"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >关联结算批次</vxe-button
        >
      </template> 
    </vxe-toolbar>-->
    <vxe-table
      ref="xTable"
      border
      resizable
      align="left"
      :auto-resize="true"
      size="mini"
      :data="table"
      :edit-rules="validRules"
      :edit-config="{ trigger: 'click', mode: 'row', activeMethod: this.activeRowMethod }"
      @edit-closed="editClosedEvent"
      :show-footer="true"
      :footer-method="footerMethodTotal"
      :max-height="$store.state.app.tableHeight"
      :tooltip-config="{ theme: 'light' }"
    >
      <vxe-table-column type="checkbox" width="50"></vxe-table-column>
      <vxe-table-column
        type="seq"
        :title="$t('addInvoice.invoiceLine.table.payableInvoiceDetailNo')"
        width="80"
      ></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) in columnList"
        :key="index"
        :fixed="item.fixed"
        :width="item.width || 120"
        :sortable="item.sortable"
        :field="item.prop"
        :title="item.label"
        :formatter="item.formatter"
        :edit-render="item.editRender"
        v-bind="item"
        show-overflow
      >
        <template v-slot:edit="{ row }">
          <!--树-->
          <template v-if="item.editRender && item.editRender.name == 'treeselect'">
            <el-select
              v-model="row[item.prop]"
              clearable
              @change="(val) => chooseTable(val, row, item.prop, row[item.prop])"
            >
              <el-option
                v-for="(i, index) in selectOPtionsFilter(item.prop, item.editRender.options)"
                :key="index"
                :disabled="filterDisabled(row, item.prop)"
                :label="i[item.editRender.label]"
                :value="i[item.editRender.value]"
              ></el-option>
            </el-select>
          </template>
          <!--选择框-->
          <template v-if="item.editRender && item.editRender.name == 'select'">
            <el-select
              v-model="row[item.prop]"
              filterable
              clearable
              @change="(val) => chooseTable(val, row, item.prop, row[item.prop])"
            >
              <el-option
                v-for="(i, index) in selectOPtionsFilter(item.prop, item.editRender.options)"
                :key="index"
                :disabled="filterDisabled(row, item.prop)"
                :label="i[item.editRender.label]"
                :value="i[item.editRender.value]"
              ></el-option>
            </el-select>
          </template>
          <!--输入框-->
          <template v-else-if="item.editRender && item.editRender.name == 'input'">
            <el-input
              v-model="row[item.prop]"
              clearable
              @change="(val) => chooseTable(val, row, item.prop)"
            />
          </template>
          <!--数字输入框-->
          <template v-else-if="item.editRender && item.editRender.name == 'number'">
            <inputNumber
              v-model="row[item.prop]"
              :controls="false"
              class="inputWidth"
              :disabled="filterDisabled(row, item.prop)"
              :precision="item.editRender['precision'] || 0"
              :min="-99999999999999999"
              :max="99999999999999999"
              @input="
                item.editRender.events
                  ? item.editRender.events(item.prop, item.editRender.headName, row)
                  : null
              "
            ></inputNumber>
          </template>
          <!--数字输入框--显示2位-->
          <template v-else-if="item.editRender && item.editRender.name == 'amountRound'">
            <inputNumber
              v-model="row[item.prop]"
              :controls="false"
              class="inputWidth"
              :disabled="filterDisabled(row, item.prop)"
              :precision="2"
              :min="-99999999999999999"
              :max="99999999999999999"
              @input="
                item.editRender.events
                  ? item.editRender.events(item.prop, item.editRender.headName, row)
                  : null
              "
            ></inputNumber>
          </template>
          <!--弹框-->
          <template v-else-if="item.editRender && item.editRender.name == 'searchTable'">
            <div @click="clickColumn(row, item.prop)">
              <search-table
                :isMultiple="true"
                v-model="row[item.prop]"
                :currentValue="row[item.prop] || null"
                :checkRowKeys="[row[item.prop]] || []"
                :searchType="item.searchType"
                :extraData="getExtraData(row, item.prop)"
                :disabled="
                  (item.prop === 'salesLadingNo' && !row['salesContractNo']) || fromContract
                    ? true
                    : false
                "
                @input="(v) => searchTable(v, row, item.prop)"
              ></search-table>
            </div>
          </template>

          <!--结算批次-->
          <template v-else-if="item.editRender && item.editRender.name == 'tableDialog'">
            <el-row>
              <el-col :span="20" class="settle" :title="row[item.prop]">{{
                row[item.prop]
              }}</el-col>
              <el-col :span="4" style="line-height: 38px; float: right">
                <i
                  class="el-icon-plus"
                  style="cursor: pointer; font-size: 16px; color: rgb(98, 153, 254)"
                  @click="(val) => settleNumber(val, row, item.prop)"
                ></i>
              </el-col>
            </el-row>
          </template>
        </template>
        <template v-slot="{ row }">
          <span v-if="item.editRender && item.editRender.name == 'select'">
            {{
              getSelectLabel(
                row[item.prop],
                selectOPtionsFilter(item.prop, item.editRender.options, true),
                item.editRender.value,
                item.editRender.label
              )
            }}
          </span>
          <span v-else-if="item.format">
            {{ row[item.prop] | formatTableColumn(item.format) }}
          </span>
          <span v-else>{{ row[item.prop] }}</span>
        </template>
      </vxe-table-column>
    </vxe-table>
    <!--匹配采购合同-->
    <purchase-contract-dialog
      ref="creatDialog"
      :differenceInvoiceFlag="differenceInvoiceFlag"
      :fromContract="fromContract"
      :data="contractData"
      :contractData="contractData"
      :feeInfo="feeInfo"
      :taxRateList="taxRateList"
      @selectContract="selectContract"
    ></purchase-contract-dialog>
    <matchMcContract
      ref="mcDialog"
      :data="contractData"
      :contractData="contractData"
      :feeInfo="feeInfo"
      :taxRateList="taxRateList"
      @selectContract="selectMcContract"
    ></matchMcContract>

    <settleInfo
      :title="$t('salePurchase.other.relative')"
      :searchColumns="searchColumns"
      :columnList="searchList"
      :API="SALES_API"
      width="1200px"
      ref="settleInfo"
      @confirm="confirm"
      propCode="settleNo"
      :checkRowKeys="checkRowKeys"
    ></settleInfo>

    <!-- 关联结算批次 按钮弹出框 -->
    <settlement-batch ref="settlementBatch" @updateSettle="updateSettle"></settlement-batch>
  </div>
</template>

<script>
  // import SiruiTable from '@/components/SiruiTable';
  import settleInfo from '@/pages/purchaseSalesCenter/components/settle-info';
  import { mapState } from 'vuex';
  // import searchTable from "./search-table";
  import searchTable from '@/components/form-item/search-table';
  import API from '@/api/financeCenter/payables.js';
  // import purchaseContractDialog from './matchPurchaseContract';
  import purchaseContractDialog from '@/components/Dialog/matchPurchaseContract';
  import matchMcContract from '@/components/Dialog/matchMcContract';
  import SALES_API from '@/api/purchaseSalesCenter/purchaseSales.js';
  import COM_API from '@/api/masterData/company';
  // import treeSelect from '@/components/form-item/tree-select';
  import { delcommafy } from '@/common/js/util';
  // import DictSelect from '@/components/DictSelect';
  import InputNumber from '@/components/form-item/input-number';
  // import InputNumberAd from '@/components/form-item/input-number-advance';
  import SettlementBatch from '@/components/SettlementBatch';
  import XEUtils from 'xe-utils';
  import { formatNumber } from '@/utils/number.js';
  export default {
    components: {
      // SiruiTable,
      searchTable,
      purchaseContractDialog,
      settleInfo,
      // treeSelect,
      // DictSelect,
      InputNumber,
      // InputNumberAd,
      matchMcContract,
      SettlementBatch,
    },
    props: [
      'canEdit',
      'table',
      'detail',
      'departmentList',
      'feeInfo',
      'exchangeRate',
      'fromContract',
    ],
    watch: {
      // 判断表格编辑功能是否禁用
      canEdit: function (newQuestion) {
        this.editConfig = newQuestion ? { trigger: 'click', mode: 'row' } : {};
      },
      baseDataRules: function () {
        this.$nextTick(() => {
          this.$refs.baseData.clearValidate();
        });
      },
      //监听发票信息变化 更新表格币种汇率等
      'feeInfo.exchangeRate': {
        handler(newV) {
          if (!this.canEdit) return;
          this.$nextTick(() => {
            let fulldata = this.$refs.xTable.getTableData().fullData;
            fulldata = fulldata.map((item) => {
              item['payableInvoiceCompanyCode'] = this.feeInfo.payableInvoiceCompanyCode;
              item.exchangeRate = newV;
              this.calLocal(item);
              return item;
            });
            this.$refs.xTable.updateData(fulldata);
          });
        },
        deep: true,
      },

      //监听发票信息变化 更新表格币种汇率等
      'feeInfo.isHnFlag': {
        handler() {
          this.$nextTick(() => {
            this.$refs.xTable.refreshColumn();
          });
        },
        deep: true,
      },
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        // 商品单位
        unitList() {
          return this.$baseRequest.getDictListByType('basic_unit');
        },
      }),
      searchColumns() {
        return [
          {
            prop: 'settleNo',
            name: this.$t('salePurchase.settleInfo.settleNo'),
            type: 'input',
            maxlength: 50,
            placeholder: this.$t('salePurchase.settleInfo.settleNoPlaceholder'),
          },
        ];
      },
      // 搜索表格列表
      searchList() {
        return [
          {
            prop: 'settleNo',
            label: this.$t('salePurchase.settleInfo.settleNo'),
          },
          {
            prop: 'settleDesc',
            label: this.$t('salePurchase.settleInfo.settleDesc'),
          },
          {
            prop: 'settleTypeName',
            label: this.$t('salePurchase.settleInfo.settleTypeName'),
          },
          {
            prop: 'shippingName',
            label: this.$t('salePurchase.settleInfo.shippingName'),
          },
          {
            prop: 'deliveryQuantity',
            label: this.$t('salePurchase.settleInfo.deliveryQuantity'),
          },
          {
            prop: 'settleStatusName',
            label: this.$t('salePurchase.settleInfo.settleStatusName'),
          },
        ];
      },
      columnList() {
        let list = [
          //费用类型
          {
            prop: 'expenseType',
            label: this.$t('addInvoice.invoiceLine.table.expenseType'),
            editRender: { name: 'select', label: 'label', value: 'value' },
            visible: false,
            width: 120,
          },
          //部门代码
          {
            prop: 'payableInvoiceDepartmentName',
            label: this.$t('addInvoice.invoiceLine.table.departmentName'),
            width: 120,
            visible: this.feeInfo.isHnFlag == 'Y',
          },
          {
            prop: 'payableInvoiceDepartmentCode',
            label: this.$t('addInvoice.invoiceLine.table.departmentName'),
            editRender: {
              name: 'select',
              label: 'personDepartmentName',
              value: 'personDepartmentCode',
            },
            required: true, // 部门
            visible: this.feeInfo.isHnFlag == 'N',
          },
          //部门名称
          {
            prop: 'payableInvoiceDepartmentCode',
            label: this.$t('addInvoice.invoiceLine.table.departmentCode'),
            width: 120,
          },
          //采购合同号
          {
            prop: 'purchaseContractNo',
            label: this.$t('addInvoice.invoiceLine.table.purchaseContractNo'),
            width: 120,
            editRender: { name: 'searchTable', props: { clearable: true } },
            searchType: 'contractHasDetail',
            checkValue: 'purchaseContractNo',
            checkCode: 'purchaseContractNo',
          },
          //采购合同行号
          {
            prop: 'purchaseContractDetailNo',
            label: this.$t('addInvoice.invoiceLine.table.purchaseContractDetailNo'),
            width: 140,
          },
          //入库批次号
          {
            prop: 'inboundBatchNo',
            label: this.$t('addInvoice.invoiceLine.table.inboundBatchNo'),
            width: 120,
          },
          //商品描述
          {
            prop: 'productDesc',
            label: this.$t('addInvoice.invoiceLine.table.productDesc'),
            width: 120,
          },
          //商品单位
          {
            prop: 'invoiceUnit',
            label: this.$t('addInvoice.invoiceLine.table.invoiceUnit'),
            width: 120,
            editRender: { name: 'select', label: 'label', value: 'value' },
          },
          //本次匹配入库数量
          {
            prop: 'matchInboundQuantity',
            label: this.$t('addInvoice.invoiceLine.table.matchInboundQuantity'),
            width: 140,
            format: 'formatQuality',
          },
          //入库单价
          {
            prop: 'inboundUnitPrice',
            label: this.$t('addInvoice.invoiceLine.table.inboundUnitPrice'),
            width: 120,
            format: 'formatPrice',
          },
          //入库汇率
          {
            prop: 'inboundExchangeRate',
            label: this.$t('addInvoice.invoiceLine.table.inboundExchangeRate'),
            width: 120,
          },
          //应付暂估原币金额
          {
            prop: 'originProvisionalAmount',
            label: this.$t('addInvoice.invoiceLine.table.originProvisionalAmount'),
            width: 130,
            format: 'formatAmountRound',
          },
          //应付暂估本币金额
          {
            prop: 'localProvisionalAmount',
            label: this.$t('addInvoice.invoiceLine.table.localProvisionalAmount'),
            width: 130,
            format: 'formatAmountRound',
          },
          /*           //溢短装数量
          {
            prop: 'overShippedQuantity',
            label: this.$t('addInvoice.invoiceLine.table.overShippedQuantity'),
            width: 120,
            format: 'formatQuality',
          }, */
          //本次收票数量
          {
            prop: 'invoiceQuantity',
            label: this.$t('addInvoice.invoiceLine.table.invoiceQuantity'),
            width: 120,
            format: 'formatQuality',
          },
          //发票单价
          {
            prop: 'invoiceUnitPrice',
            label: this.$t('addInvoice.invoiceLine.table.invoiceUnitPrice'),
            width: 120,
            format: 'formatPrice',
          },
          /* //发票含税单价
          {
            prop: 'invoiceUnitPriceWithTax',
            label: this.$t('addInvoice.invoiceLine.table.invoiceUnitPriceWithTax'),
            width: 120,
            format: 'formatPrice',
          }, */
          //原币发票价差
          {
            prop: 'originInvoiceDifferPrice',
            label: this.$t('addInvoice.invoiceLine.table.originInvoiceDifferPrice'),
            width: 120,
            format: 'formatAmountRound',
          },
          //本币发票价差
          {
            prop: 'localInvoiceDifferPrice',
            label: this.$t('addInvoice.invoiceLine.table.localInvoiceDifferPrice'),
            width: 120,
            format: 'formatAmountRound',
          },
          //不含税金额
          {
            prop: 'amountWithoutTax',
            label: this.$t('addInvoice.invoiceLine.table.amountWithoutTax'),
            disabled: false,
            width: 120,
            format: 'formatAmountRound',
          },
          //税率
          { prop: 'taxRate', label: this.$t('addInvoice.invoiceLine.table.taxRate'), width: 120 },
          //税额
          {
            prop: 'taxAmount',
            label: this.$t('addInvoice.invoiceLine.table.taxAmount'),
            editRender: {
              name: 'amountRound',
              events: this.changeAmount,
              headName: 'taxAmount',
              attrs: { disabled: false },
            },
            disabled: false,
            width: 120,
            format: 'formatAmountRound',
          },
          //总额
          {
            prop: 'totalAmount',
            label: this.$t('addInvoice.invoiceLine.table.totalAmount'),
            editRender: {
              name: 'amountRound',
              events: this.changeAmount,
              headName: 'amountWithoutTax',
              attrs: { disabled: false },
            },
            width: 120,
            format: 'formatAmountRound',
          },
          //汇率
          {
            prop: 'exchangeRate',
            label: this.$t('addInvoice.invoiceLine.table.exchangeRate'),
            width: 120,
          },
          /* //税码
          {
            prop: 'taxCode',
            label: this.$t('addInvoice.invoiceLine.table.taxCode'),
            editRender: {
              name: 'select',
              label: 'label',
              value: 'value',
              events: this.changeAmount,
            },
            width: 220,
          }, */
          //本币不含税金额
          {
            prop: 'domesticTotalWithoutTaxAmount',
            label: this.$t('addInvoice.invoiceLine.table.domesticTotalWithoutTaxAmount'),
            width: 120,
            format: 'formatAmountRound',
          },
          //本币税额
          {
            prop: 'domesticTaxAmount',
            label: this.$t('addInvoice.invoiceLine.table.domesticTaxAmount'),
            width: 120,
            format: 'formatAmountRound',
          },
          //本币总额
          {
            prop: 'domesticTotalAmount',
            label: this.$t('addInvoice.invoiceLine.table.domesticTotalAmount'),
            width: 120,
            format: 'formatAmountRound',
          },
          /* {
            prop: 'salesContractNo',
            label: this.$t('addInvoice.invoiceLine.table.salesContractNo'),
            editRender: { name: 'searchTable' },
            width: 120,
            searchType: 'contract',
            checkValue: 'salesContractNo',
            checkCode: 'salesContractNo',
          },
          {
            prop: 'salesLadingNo',
            label: this.$t('addInvoice.invoiceLine.table.salesLadingNo'),
            editRender: { name: 'searchTable' },
            width: 120,
            searchType: 'salesLadingDetail',
            heckValue: 'salesLadingNo',
            checkCode: 'salesLadingNo',
          },
          { prop: 'salesLadingDetailNo', label: '提单行号' },
          { prop: 'productNo', label: '商品编码' },
          { prop: 'productDesc', label: '商品描述' },
          //结算批次
          {
            prop: 'batchSettleNo',
            label: this.$t('addInvoice.invoiceLine.table.batchSettleNo'),
            width: 180,
            editRender: { name: 'searchTable' },
            searchType: 'settle',
            extraData: '{settleCompanyNo:feeInfo.payableInvoiceCompanyCode,settleDepartmentNo:""}',
            heckValue: 'batchSettleNo',
            checkCode: 'batchSettleNo',
          }, */
          // { prop: "batchSettleNo",
          //   label: this.$t("addInvoice.invoiceLine.table.batchSettleNo"),
          //   editRender: { name: 'searchTable' },
          //   width: 120,
          //   searchType: 'batchSettle',
          //   heckValue: "settleNo",
          //   checkCode: "settleNo",
          // },
          {
            prop: 'mark',
            label: this.$t('addInvoice.invoiceLine.table.mark'),
            editRender: { name: 'input' },
            width: 120,
          },
          /* {
            prop: 'isReverseAlias',
            label: this.$t('addInvoice.invoiceLine.table.isReverseAlias'),
            width: 120,
            formatter: this.$formatter.yesOrNo,
          }, */
        ];
        return list;
      },
      validRules() {
        const prefixInput = this.$t('addInvoice.invoiceLine.rules.input');
        const prefixSelect = this.$t('addInvoice.invoiceLine.rules.select');

        const saleLading = (rule, value, callback, { row }) => {
          // 冲减收入 销售合同 销售提单必填
          if (row.expenseGroup == 'REV') {
            row.salesContractNo && row.salesLadingDetailNo && row.salesLadingNo
              ? callback()
              : callback(new Error('费用为冲减收入时，销售合同,销售提单号及行号必填'));
          } else {
            callback();
          }
        };
        return {
          expenseGroup: [
            {
              required: true,
              message: prefixSelect + this.$t('addInvoice.invoiceLine.table.expenseGroup'),
            },
          ],
          // expenseType: [
          //   {
          //     required: true,
          //     message: prefixSelect + this.$t('addInvoice.invoiceLine.table.expenseType'),
          //   },
          // ],
          payableInvoiceDepartmentCode: [
            {
              required: true,
              message:
                prefixSelect + this.$t('addInvoice.invoiceLine.table.payableInvoiceDepartmentCode'),
            },
          ],
          payableInvoiceDepartmentName: [
            {
              required: true,
              message:
                prefixSelect + this.$t('addInvoice.invoiceLine.table.payableInvoiceDepartmentName'),
            },
          ],
          amountExcludingTax: [
            {
              required: true,
              message: prefixInput + this.$t('addInvoice.invoiceLine.table.amountExcludingTax'),
            },
          ],
          amountWithoutTax: [
            {
              required: true,
              message: prefixInput + this.$t('addInvoice.invoiceLine.table.amountWithoutTax'),
            },
          ],
          taxCode: [
            {
              required: true,
              message: prefixSelect + this.$t('addInvoice.invoiceLine.table.taxCode'),
            },
          ],
          taxRate: [
            {
              required: true,
              message: prefixInput + this.$t('addInvoice.invoiceLine.table.taxRate'),
            },
          ],
          taxAmount: [
            {
              required: true,
              message: prefixInput + this.$t('addInvoice.invoiceLine.table.taxAmount'),
            },
          ],
          totalAmount: [
            {
              required: true,
              message: prefixInput + this.$t('addInvoice.invoiceLine.table.totalAmount'),
            },
          ],
          emark: [{ max: 50, message: '文件名长度在 1 到 50 个字符' }],
          exchangeRate: [
            {
              required: true,
              message: prefixSelect + this.$t('addInvoice.invoiceLine.table.exchangeRate'),
            },
          ],
          salesContractNo: [{ validator: saleLading }],
          salesLadingDetailNo: [{ validator: saleLading }],
        };
      },
    },
    mounted() {
      // 初始化表格是否编辑
      this.editConfig = this.canEdit ? { trigger: 'click', mode: 'row' } : {};
      if (!this.detail) {
        // this.table=[]
      }
      this.getDictList();
    },
    data() {
      return {
        load: false,
        footerTotalCols: {
          amount: [
            'domesticTotalAmount',
            'domesticTotalWithoutTaxAmount',
            'domesticTaxAmount',
            'localInvoiceDifferPrice',
            'localProvisionalAmount',
            'amountWithoutTax',
            'taxAmount',
            'totalAmount',
            'originInvoiceDifferPrice',
            'originProvisionalAmount',
          ],
          quantity: ['invoiceQuantity'],
        },
        totalObj: {
          invoiceQuantity: 0,
        },
        salesLadingNoOptions: [], //销售提单号
        contractData: {}, //匹配采购合同
        checkRowKeys: [],
        SALES_API: SALES_API.GET_SETTLE_API,
        COM_API: COM_API.LIST_COMPANY_API,
        deptTreeOptions: [], //部门树
        taxRateList: [], //税率列表
        expenseGroupList: [], //费用大类
        expenseGroupListAll: [], //所有费用大类--因为新增委托加工
        expenseTypeList: [], //费用类型
        expenseTypeListAll: [], // 所有的费用类型--小类用于展示
        differenceInvoiceFlag: false, //是否为差额发票  当行信息有入库数量为0的数据时 表示为差额发票
      };
    },

    methods: {
      // 通用底部合计总数 - footerTotalCols定义在各个具体文件中，示例如下
      // footerTotalCols:{amount:['contractTotalAmount'],quantity:['productQuantity']}, //底部合计列-字段名，数字类型（金额amount，数量quantity等）判断小数点

      footerMethodTotal({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            for (let key in this.footerTotalCols) {
              if (this.footerTotalCols[key].includes(column.property)) {
                let total = XEUtils.calSum(data, column.property);
                let point = this.$globalVar.aPoint;
                if (key == 'quantity') {
                  point = this.$globalVar.qPoint;
                }
                let result = formatNumber(total, point);
                if (column.property == 'invoiceQuantity') this.totalObj.invoiceQuantity = result;
                return result;
              }
            }
          }),
        ];
      },
      handleSettleBatch() {
        // 关联结算批次
        const selectedList = this.$refs.xTable.getSelectRecords(); // 获取选中数据
        if (selectedList.length != 1) {
          return this.$message({ showClose: true, message: '请选择一条数据', type: 'error' });
        }
        if (!selectedList[0].id) {
          return this.$message({ showClose: true, message: '该数据尚未保存', type: 'error' });
        }
        this.$refs.settlementBatch.open({
          settleCompanyNo: this.feeInfo.payableInvoiceCompanyCode,
          settleDepartmentNo: '',
        });
      },

      updateSettle(v) {
        let rows = this.$refs.xTable.getCheckboxRecords();
        rows.forEach((row) => {
          row['batchSettleNo'] = v[0].settleNo;
        });
        this.$axios.post(API.UPDATE_SETTLE, rows).then((res) => {
          if (res.data.code == 0) {
            this.$refs.settlementBatch.close();
            this.$emit('getDetail');
          } else {
            return this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 金额变动
      changeAmount(field, name, row) {
        console.log(field, row);
        let isCostandCGHK =
          (row.expenseGroup == 'COST' && row.expenseType == 'CGHK') ||
          row.expenseGroup == 'COST-CON';
        if (field == 'taxAmount') {
          // 不含税金额=总额-税额
          row['amountWithoutTax'] = this.$cal.calCommon(
            row['totalAmount'],
            row['taxAmount'] || 0,
            '-',
            'amount'
          );
        }
        if (field == 'amountWithoutTax') {
          // 税额=总额-不含税金额
          row['taxAmount'] = this.$cal.calCommon(
            row['totalAmount'],
            row['amountWithoutTax'] || 0,
            '-',
            'amount'
          );
        }
        if (field == 'totalAmount') {
          // 不含税金额 = 总额/（1+税率）
          row['amountWithoutTax'] = this.$cal.calCommon(
            row['totalAmount'],
            this.$cal.calCommon(1, row['taxRate'], '+'),
            '/',
            'amount'
          );
          // 税额=总额-不含税金额
          row['taxAmount'] = this.$cal.calCommon(
            row['totalAmount'],
            row['amountWithoutTax'] || 0,
            '-',
            'amount'
          );
        }
        // 发票含税单价 = 总额/本次收票数量
        row['invoiceUnitPriceWithTax'] = isCostandCGHK
          ? this.$cal.calCommon(row['totalAmount'] || 0, row['invoiceQuantity'], '/', 'price')
          : '';
        // 发票单价 = 不含税金额/本次收票数量
        row['invoiceUnitPrice'] = isCostandCGHK
          ? this.$cal.calCommon(
              row['amountWithoutTax'] || 0,
              row['invoiceQuantity'] || 0,
              '/',
              'price'
            )
          : ''; // //应付暂估原币金额=本次匹配入库数量*入库单价 (原逻辑)
        // 原币发票价差=（原币不含税金额-原币不含税暂估金额）
        const originInvoiceDifferPrice = isCostandCGHK
          ? this.$cal.calCommon(
              row['amountWithoutTax'] || 0,
              row['originProvisionalAmount'] || 0,
              '-',
              'amount'
            )
          : '';
        row['originInvoiceDifferPrice'] = isCostandCGHK ? originInvoiceDifferPrice : '';

        this.calLocal(row);
      },

      // 计算本币金额
      calLocal(row) {
        let isCostandCGHK =
          (row.expenseGroup == 'COST' && row.expenseType == 'CGHK') ||
          row.expenseGroup == 'COST-CON';
        //本币总额
        row['domesticTotalAmount'] = this.$cal.calCommon(
          row['totalAmount'],
          row['exchangeRate'] || 0,
          '*',
          'amount'
        );
        //本币不含税金额
        row['domesticTotalWithoutTaxAmount'] = this.$cal.calCommon(
          row['amountWithoutTax'],
          row['exchangeRate'] || 0,
          '*',
          'amount'
        );
        //本币税额 = 本币总额-本币不含税金额
        row['domesticTaxAmount'] = this.$cal.calCommon(
          row['domesticTotalAmount'],
          row['domesticTotalWithoutTaxAmount'],
          '-',
          'amount'
        );
        // 本币发票价差= 本币不含税金额-应付暂估本币金额
        row['localInvoiceDifferPrice'] = isCostandCGHK
          ? this.$cal.calCommon(
              row['domesticTotalWithoutTaxAmount'],
              row['localProvisionalAmount'],
              '-',
              'amount'
            )
          : '';
        this.updateBillInfo();
      },
      editClosedEvent() {},
      getExtraData(row, type) {
        let extraData = {};
        if (type == 'salesContractNo') {
          extraData = {
            contractCategory: 'sales',
            contractDetailCategory: 'HT07,HT08',
            contractStatus: 'ZT03',
            contractBusinessDepartment: row.payableInvoiceDepartmentCode,
          };
        } else if (type == 'purchaseContractNo') {
          extraData = {
            contractCategory: 'purchase',
            contractDetailCategory: row.expenseGroup == 'COST-CON' ? 'HT10' : 'HT03,HT04',
            contractStatus: 'ZT03',
          };
          if (row.expenseGroup == 'COST' && row.expenseType == 'CGHK')
            extraData['supplierNo'] = this.feeInfo.invoiceUnitNo;
        } else if (type == 'payableInvoiceDepartmentCode') {
          extraData = {
            belongCompanyCode:
              row['payableInvoiceCompanyCode'] || this.feeInfo.payableInvoiceCompanyCode,
          };
        } else if (type == 'batchSettleNo') {
          extraData = {
            settleCompanyNo: this.feeInfo.payableInvoiceCompanyCode,
            settleDepartmentNo: row.payableInvoiceDepartmentCode,
          };
        } else if (type == 'salesLadingNo') {
          extraData = {
            contractNo: row.salesContractNo,
            ladingStatus: 'TDZT03',
          };
        }
        return extraData;
      },
      getSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);

        if (value == 'D00195') console.log(value, list, item);
        return item ? item[labelField] : null;
      },
      activeRowMethod({ row }) {
        if (this.canEdit && row.expenseGroup) this.getExpenseTypeList(row.expenseGroup);
        //禁用编辑
        return this.canEdit;
      },
      selectOPtionsFilter(filed, options, flag) {
        //flag true时表示为不可编辑显示状态
        let result;
        switch (filed) {
          case 'payableInvoiceDepartmentCode':
            /* let departmentList = this.departmentList
          result = this.departmentList.map(it=>{
            it.personDepartmentName = it.personDepartmentCode+ "-" +it.personDepartmentName
            return it
          }) */
            result = this.departmentList;
            break;
          case 'expenseGroup':
            result = this.expenseGroupList;
            break;
          case 'expenseType':
            result = flag ? this.expenseTypeListAll : this.expenseTypeList;
            console.log('expenseTypeList', result);
            break;
          case 'taxCode':
            result = this.taxRateList;
            break;
          case 'invoiceUnit':
            result = this.unitList;
            break;
          default:
            result = options;
        }
        return result;
      },
      // 选择框选择事件
      chooseTable(val, row, field) {
        row[field] = val;
        let isCostandCGHK =
          (row.expenseGroup == 'COST' && row.expenseType == 'CGHK') ||
          row.expenseGroup == 'COST-CON';
        if (field === 'taxCode') {
          // 税率
          row['taxRate'] = this.taxRateList.find((it) => it.taxCode == val).taxRate;
          // 税额 = 含税总额*税率(错的)  = 含税金额/(1+税率）*税率
          let step1 = this.$cal.calCommon(1, row['taxRate'], '+');
          let step2 = this.$cal.calCommon(row['totalAmount'], step1, '/');
          row['taxAmount'] = this.$cal.calCommon(step2, row['taxRate'], '*', 'amount');
          // 不含税金额=总额-税额
          row['amountWithoutTax'] = this.$cal.calCommon(
            row['totalAmount'],
            row['taxAmount'] || 0,
            '-',
            'amount'
          );

          // 发票含税单价 = 总额/本次收票数量
          row['invoiceUnitPriceWithTax'] = isCostandCGHK
            ? this.$cal.calCommon(row['totalAmount'] || 0, row['invoiceQuantity'], '/', 'price')
            : '';
          // 发票单价 = 不含税金额/本次收票数量
          row['invoiceUnitPrice'] = isCostandCGHK
            ? this.$cal.calCommon(
                row['amountWithoutTax'] || 0,
                row['invoiceQuantity'] || 0,
                '/',
                'price'
              )
            : '';
          // 原币发票价差=（原币不含税金额-原币不含税暂估金额）
          const originInvoiceDifferPrice = isCostandCGHK
            ? this.$cal.calCommon(
                row['amountWithoutTax'] || 0,
                row['originProvisionalAmount'] || 0,
                '-',
                'amount'
              )
            : '';
          row['originInvoiceDifferPrice'] = isCostandCGHK ? originInvoiceDifferPrice : '';

          this.calLocal(row);
        } else if (field === 'expenseGroup') {
          //费用大类
          this.getExpenseTypeList(row['expenseGroup']);
          row['expenseType'] = '';
          if (val !== 'COST') {
            //费用大类为成本时才需要匹配合同
            row = this.resetContract(row);
          }
        } else if (field === 'expenseType') {
          // 费用类型
          if (val !== 'CGHK') {
            //不为费用大类清空row
            row = this.resetContract(row);
          }
        } else if (field == 'payableInvoiceDepartmentCode') {
          row['payableInvoiceDepartmentName'] = !row[field]
            ? ''
            : this.departmentList.find(
                (it) => it.personDepartmentCode == row.payableInvoiceDepartmentCode
              ).personDepartmentName;
        }
      },

      // 计算合计金额
      calTotal() {
        let fulldata = this.$refs.xTable.getTableData().fullData;
        let total = {
          originalTotalAmount: 0,
          originalTotalWithoutTaxAmount: 0,
          originalTaxAmount: 0,
          domesticTotalAmount: 0,
          domesticTotalWithoutTaxAmount: 0,
          domesticTaxAmount: 0,
        };
        fulldata.map((item) => {
          total.originalTotalAmount = this.$cal.calCommon(
            item.totalAmount,
            total.originalTotalAmount,
            '+',
            'amount'
          );
          total.originalTotalWithoutTaxAmount = this.$cal.calCommon(
            delcommafy(item.amountWithoutTax),
            delcommafy(total.originalTotalWithoutTaxAmount),
            '+',
            'amount'
          );
          total.originalTaxAmount = this.$cal.calCommon(
            delcommafy(item.taxAmount),
            delcommafy(total.originalTaxAmount),
            '+',
            'amount'
          );
          total.domesticTotalAmount = this.$cal.calCommon(
            delcommafy(item.domesticTotalAmount),
            delcommafy(total.domesticTotalAmount),
            '+',
            'amount'
          );
          total.domesticTotalWithoutTaxAmount = this.$cal.calCommon(
            delcommafy(item.domesticTotalWithoutTaxAmount),
            delcommafy(total.domesticTotalWithoutTaxAmount),
            '+',
            'amount'
          );
          total.domesticTaxAmount = this.$cal.calCommon(
            delcommafy(item.domesticTaxAmount),
            delcommafy(total.domesticTaxAmount),
            '+',
            'amount'
          );
        });
        return total;
      },

      // 打开计算批次
      settleNumber(val, row, field) {
        console.log(val, row, field);
        // 将点击的结算批次行项目数据存起来
        const extraData = {
          settleDepartmentNo: row.departmentCode,
          associationType: this.$route.query.contractCategory == 'sales' ? '2' : '1',
          associationNo: row.contractNo,
          associationDetailNo: row.contractDetailNo,
        };
        this.checkRowKeys = row.settleBatchNumber ? row.settleBatchNumber.split(',') : [];
        this.$refs.settleInfo.handleOpen(extraData);
      },
      // 确定
      confirm(multipleSelection) {
        //如果是变动价格，则需要当前操作的行项目明细
        let settleNo = [];
        multipleSelection.some((item) => {
          settleNo.push(item.settleNo);
        });
        let row = this.$refs.xTable.getActiveRecord().row;
        row.batchSettleNo = settleNo.join(',');
        // 关闭弹窗
        this.$refs.settleInfo.dialogVisible = false;
      },
      // 匹配采购合同
      handleMatching() {
        let selectRecords = this.$refs.xTable.getCheckboxRecords();
        // const allRecords = this.$refs.xTable.getTableData().fullData;

        /* //多选时判断
      let preArr = ""
      let someFlag = true
      for(let i=0;i<selectRecords.length;i++){
        if(i>0) {
          let nowArr = selectRecords[i].expenseGroup + selectRecords[i].expenseType + selectRecords[i].inboundDepartmentNo;
          if(nowArr!==preArr){
            someFlag = false;
            break;
          }
        }
        let preArr = selectRecords[i].expenseGroup + selectRecords[i].expenseType + selectRecords[i].inboundDepartmentNo
      }
      if(!someFlag){
         this.$message({
          showClose: true,
          message: "多选匹配时费用大类、费用类型、部门代码需要一致！",
          type: "error"
        });
        return;
      } */

        if (selectRecords.length !== 1) {
          this.$message({
            showClose: true,
            message: '请选择一条数据修改',
            type: 'error',
          });
          return;
        }
        if (
          selectRecords[0].expenseGroup != 'COST' &&
          selectRecords[0].expenseGroup != 'COST-CON'
        ) {
          //费用大类成本可以点击
          this.$message({
            showClose: true,
            message: '当前所选数据费用大类必须为成本或者委托加工才可操作',
            type: 'error',
          });
          return;
        } else if (!selectRecords[0].payableInvoiceDepartmentCode && this.feeInfo.isHnFlag == 'N') {
          //海宁匹配合同的时候 不筛选部门
          this.$message({
            showClose: true,
            message: '请先选择部门',
            type: 'error',
          });
          return;
        }

        if (selectRecords[0].expenseGroup == 'COST-CON') {
          this.$refs.mcDialog.defaultVisible = true;
        } else {
          this.$refs.creatDialog.defaultVisible = true;
        }
        this.contractData = selectRecords[0];
      },
      // 新增行
      async insertEvent() {
        this.$emit('validate');
        this.$nextTick(() => {
          this.$refs.xTable
            .validate()
            .then(() => {
              // 费用大类为委托加工，则所有大类均为委托加工
              let fullData = this.$refs.xTable.getTableData().fullData;
              let expenseGroup = 'COST';
              let expenseType = 'CGHK';
              if (fullData[0]) {
                // 委托加工
                if (fullData[0].expenseGroup == 'COST-CON') {
                  expenseGroup = 'COST-CON';
                  expenseType = 'JGF';
                  this.expenseGroupList = this.expenseGroupListAll.filter(
                    (item) => item.value == 'COST-CON'
                  );
                } else {
                  this.expenseGroupList = this.expenseGroupListAll.filter(
                    (item) => item.value != 'COST-CON'
                  );
                }
              } else {
                this.expenseGroupList = XEUtils.clone(this.expenseGroupListAll, true);
              }
              const record = {
                expenseGroup,
                expenseType,
                payableInvoiceDepartmentCode:
                  this.userInfo.companyCode == this.feeInfo.payableInvoiceCompanyCode &&
                  this.feeInfo.isHnFlag == 'N'
                    ? this.userInfo.departmentCode
                    : '',
                payableInvoiceDepartmentName:
                  this.userInfo.companyCode == this.feeInfo.payableInvoiceCompanyCode &&
                  this.feeInfo.isHnFlag == 'N'
                    ? this.userInfo.departmentName
                    : '',
                payableInvoiceCompanyCode: this.feeInfo.payableInvoiceCompanyCode,
                amountWithoutTax: 0,
              };
              this.$refs.xTable.insert(record).then(({ row }) => {
                row.exchangeRate = this.exchangeRate;
                this.$refs.xTable.setActiveRow(row);
              });
            })
            .catch((err) => {
              console.log(err);
            });
        });
      },
      //删除一行
      deleteEvent() {
        let selectRecords = this.$refs.xTable.getCheckboxRecords();
        if (selectRecords.length) {
          this.$refs.xTable.removeSelecteds();
          this.checkDifferenceInvoice();
        } else {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        }
        this.updateBillInfo();
      },
      // 更新发票头
      updateBillInfo() {
        this.$nextTick(() => {
          this.$emit('calTotal', true);
        });
      },
      //选择部门代码
      selectDepartCode({ row }) {
        console.log(row, row.departmentCode);
      },
      // 获取字典表
      getDictList() {
        // const tenantCode = this.userInfo.tenantCode; // 租户编码
        //部门树
        this.$baseRequest
          .getDepartmentTree({
            tenantCode: this.userInfo.tenantCode,
            adminFlag: this.userInfo.adminFlag,
          })
          .then((res) => {
            this.deptTreeOptions = res;
          });
        //税率
        this.$baseRequest.getTaxRate().then((res) => {
          this.taxRateList = res.filter((it) => it.taxType == 'IT');
        });

        //费用大类
        this.$baseRequest.getExpenseType({ leafFlag: 'N' }).then((res) => {
          this.expenseGroupListAll = res;
          this.expenseGroupList = res;
        });
        //费用类型 -- 小类
        this.$baseRequest.getExpenseType({ leafFlag: 'Y' }).then((res) => {
          this.expenseTypeListAll = res;
        });
      },

      //费用类型 -- 小类
      getExpenseTypeList(val) {
        this.$baseRequest
          .getExpenseType({ parentExpenseTypeCode: val, leafFlag: 'Y' })
          .then((res) => {
            this.expenseTypeList = res;
          });
      },
      // 弹出框选择事件
      searchTable(v, row, prop) {
        if (prop === 'salesContractNo') {
          row['salesContractNo'] = v ? v[0]['contractNo'] : '';
          row['salesLadingNo'] = '';
          row['salesLadingDetailNo'] = '';
        } else if (prop === 'salesLadingNo') {
          row['salesLadingNo'] = v ? v[0]['ladingNo'] : '';
          row['salesLadingDetailNo'] = v ? v[0]['ladingDetailNo'] : '';
          row['productNo'] = v ? v[0]['productNo'] : '';
          row['productDesc'] = v ? v[0]['productDesc'] : '';
        } else if (prop === 'batchSettleNo') {
          row['batchSettleNo'] = v[0]['settleNo'];
        } else if (prop === 'purchaseContractNo') {
          this.resetContract(row);
          row['purchaseContractNo'] = v[0]['contractNo'];
          row['purchaseContractDetailNo'] = v[0]['contractDetailNo'];
        }
      },
      // 判断销售订单选择完选择销售合同
      clickColumn(row, prop) {
        if (prop === 'salesLadingNo' && !row['salesContractNo']) {
          this.$message({
            showClose: true,
            message: '请先选择合同号再选择提单号',
            type: 'error',
          });
        }
      },
      // 置空业务字段
      resetContract(row) {
        XEUtils.objectEach(row, (item, key) => {
          // 对象迭代器，只能用于遍历对象，性能高于 each
          let leftFlag =
            [
              'payableInvoiceCompanyCode',
              'payableInvoiceCompanyName',
              'payableInvoiceDepartmentCode',
              'payableInvoiceDepartmentName',
              'expenseGroup',
              'expenseType',
              'id',
              'exchangeRate',
            ].indexOf(key) != -1;
          if (!leftFlag) row[key] = null;
          row['amountWithoutTax'] = 0;
        });
      },
      // 根据行信息本次匹配入库数量判断是否为差额发票
      checkDifferenceInvoice() {
        let fullData = this.$refs.xTable.getTableData().fullData;
        let flag = fullData.findIndex(
          (item) => item.expenseType == 'CGHK' && item.matchInboundQuantity == 0
        );
        console.log(flag);
        this.differenceInvoiceFlag = flag != -1;
        if (flag) this.loading.endLoading();
        return this.differenceInvoiceFlag;
      },
      // 匹配采购合同
      selectContract(data) {
        let fullData = this.$refs.xTable.getTableData().fullData;
        let selectRecords = this.$refs.xTable.getCheckboxRecords();
        let selectIndex = fullData.findIndex((it) => it._XID == selectRecords[0]._XID);
        let isSetCheckRow = false; //优先填入本地勾选行，再新增插入行
        let existArr = [];
        data.map((it) => {
          // 存在已有入库单--入库单行ID+大类+小类 不重复
          let existConditon =
            it.id + '-' + selectRecords[0].expenseGroup + '-' + selectRecords[0].expenseType;
          let existIndex = fullData.findIndex((item) => {
            let fullDataItem =
              item.inboundDetailId + '-' + item.expenseGroup + '-' + item.expenseType;
            return fullDataItem == existConditon;
          });
          let row = { exchangeRate: selectRecords[0].exchangeRate };
          row['expenseGroup'] = selectRecords[0].expenseGroup;
          row['expenseType'] = selectRecords[0].expenseType;
          if (this.feeInfo.isHnFlag == 'Y') {
            row['payableInvoiceDepartmentCode'] = it.inboundDepartmentNo;
            row['payableInvoiceDepartmentName'] = it.inboundDepartmentName;
          } else {
            row['payableInvoiceDepartmentCode'] = selectRecords[0].payableInvoiceDepartmentCode;
            row['payableInvoiceDepartmentName'] = selectRecords[0].payableInvoiceDepartmentName;
          }
          let matchInboundQuantity = it.matchInboundQuantity || 0;
          let businessVariablePriceWithoutTax = it.businessVariablePriceWithoutTax || 0;
          let invoiceQuantity = it.invoiceQuantity || 0;
          let invoiceUnitPrice = it.invoiceUnitPrice;
          let invoiceUnitPriceWithTax = it.invoiceUnitPriceWithTax;
          let exchangeRate = it.exchangeRate || 0;
          let isCostandCGHK =
            (row.expenseGroup == 'COST' && row.expenseType == 'CGHK') ||
            row.expenseGroup == 'COST-CON';
          row['invoiceUnit'] = isCostandCGHK ? it.productUnit : ''; //单位
          row['matchInboundQuantity'] = isCostandCGHK ? matchInboundQuantity : ''; //本次匹配入库数量
          row['inboundUnitPrice'] = isCostandCGHK ? businessVariablePriceWithoutTax : ''; //入库单价
          row['inboundExchangeRate'] = isCostandCGHK ? exchangeRate : ''; //入库汇率单价
          row['inboundQuantity'] = isCostandCGHK ? it.inboundQuantity : ''; //业务入库数
          row['inboundPureAmount'] = isCostandCGHK ? it.businessVariablePricePureAmount : ''; //业务入库暂估净值,变动价净值(业务)
          row['companyInboundPureAmount'] = isCostandCGHK ? it.companyVariablePricePureAmount : ''; //入库汇率
          if (isCostandCGHK) {
            // 只有成本采购货款时才需要计算暂估
            if (it.matchInboundQuantity == it.matchAvailableQuantity && it.matchAvailableAmount) {
              //本次匹配入库数量 == 可匹配数量 表示最后一次匹配采购合同  需要将入库单中的可匹配金额负值为暂估金额
              row['originProvisionalAmount'] = it.matchAvailableAmount;
              row['localProvisionalAmount'] = it.companyMatchAvailableAmount;
              if (it.returnNo) {
                row['originProvisionalAmount'] = -it.matchAvailableAmount;
                row['localProvisionalAmount'] = -it.companyMatchAvailableAmount;
              }
            } else {
              // //应付暂估原币金额=本次匹配入库数量*入库单价 (原逻辑)
              // 应付暂估 = 净值总额*发票数量/|入库数量|(现逻辑)
              let step1 = this.$cal.calCommon(invoiceQuantity, row['inboundPureAmount'], '*');
              row['originProvisionalAmount'] = this.$cal.calCommon(
                step1,
                Math.abs(row['inboundQuantity']),
                '/',
                'amount'
              );
              //应付暂估本币金额=本次匹配入库数量*入库单价*入库汇率=应付暂估原币金额*入库汇率 (原逻辑)
              // 本币应付暂估 = 本币净值总额*发票数量/|入库数量|(现逻辑)
              let step1Local = this.$cal.calCommon(
                invoiceQuantity,
                row['companyInboundPureAmount'],
                '*'
              );
              row['localProvisionalAmount'] = this.$cal.calCommon(
                step1Local,
                Math.abs(row['inboundQuantity']),
                '/',
                'amount'
              );
            }
            if (invoiceQuantity === 0) {
              // 匹配数量0时，直接设置暂估为0  不用计算 也不用取回填值
              row['originProvisionalAmount'] = 0;
              row['localProvisionalAmount'] = 0;
            }
          } else {
            row['originProvisionalAmount'] = '';
            row['localProvisionalAmount'] = '';
          }
          console.log(row.originProvisionalAmount);
          row['overShippedQuantity'] = isCostandCGHK ? it.overShippedQuantity || 0 : ''; //益端装数量
          row['invoiceQuantity'] = isCostandCGHK ? invoiceQuantity : ''; //本次收票数量
          row['invoiceUnitPrice'] = isCostandCGHK ? invoiceUnitPrice || 0 : ''; //发票单价
          row['invoiceUnitPriceWithTax'] = isCostandCGHK ? invoiceUnitPriceWithTax || 0 : ''; //发票含税单价
          row['inboundAmountWithTax'] = isCostandCGHK ? it.businessVariablePriceWithTax || 0 : ''; //业务入库单上业务入库暂估含税金额,变动价净值(业务)'
          row['companyInboundAmountWithTax'] = isCostandCGHK
            ? it.companyVariablePriceWithTax || 0
            : ''; //业务入库单上本币业务入库暂估含税金额,变动价净值(业务)
          row['productNo'] = it.productNo; //商品编码
          row['productDesc'] = it.productDesc; //商品描述
          row['inboundCode'] = it.businessInboundNo; //业务入库单号
          row['returnNo'] = it.returnNo; //退货单号
          row['returnDetailNo'] = it.returnDetailNo; //退货单行号
          row['inboundDetailId'] = it.id; //业务入库单行号
          row['purchaseContractNo'] = it.contractNo; //采购合同号
          row['purchaseContractDetailNo'] = it.contractDetailNo; //采购合同行号
          row['inboundBatchNo'] = it.businessInboundBatchNo; //业务入库单批次号
          row['amountWithoutTax'] = it.originalTotalWithoutTaxAmount || 0; //本币不含税金额
          // 原币发票价差=（原币不含税金额-原币不含税暂估金额）
          const originInvoiceDifferPrice1 = isCostandCGHK
            ? this.$cal.calCommon(
                row['amountWithoutTax'],
                row['originProvisionalAmount'],
                '-',
                'amount'
              )
            : '';
          row['originInvoiceDifferPrice'] = isCostandCGHK ? originInvoiceDifferPrice1 : '';
          row['taxCode'] = it.taxCode; //税码
          row['taxRate'] = it.taxRate; //税率
          row['taxAmount'] = it.taxAmount || 0; //税额
          row['totalAmount'] = it.totalAmount; //总额
          //本币总额 = 总额*汇率
          row['domesticTotalAmount'] = this.$cal.calCommon(
            row['totalAmount'] || 0,
            row['exchangeRate'],
            '*',
            'amount'
          );
          // 本币不含税总额=总额*汇率
          row['domesticTotalWithoutTaxAmount'] = this.$cal.calCommon(
            it.originalTotalWithoutTaxAmount || 0,
            row['exchangeRate'],
            '*',
            'amount'
          );
          // 本币税额= 本币总额 - 本币不含税总额
          row['domesticTaxAmount'] = this.$cal.calCommon(
            row['domesticTotalAmount'],
            row['domesticTotalWithoutTaxAmount'],
            '-',
            'amount'
          );
          // 本币发票价差= 本币不含税金额-应付暂估本币金额
          row['localInvoiceDifferPrice'] = isCostandCGHK
            ? this.$cal.calCommon(
                row['domesticTotalWithoutTaxAmount'],
                row['localProvisionalAmount'],
                '-',
                'amount'
              )
            : '';
          row = this.$baseRequest.assignObj(row);
          if (existIndex != -1) {
            // 存在已有入库单
            existArr.push(existIndex + 1);
            fullData[existIndex] = row;
            this.$refs.xTable.loadData(fullData);
            if (existIndex == selectIndex) isSetCheckRow = true;
          } else {
            if (isSetCheckRow) {
              this.$refs.xTable.insertAt(row);
            } else {
              fullData[selectIndex] = row;
              this.$refs.xTable.loadData(fullData);
              isSetCheckRow = true;
            }
          }
        });
        if (existArr.length > 0)
          this.$message({
            showClose: true,
            message: '行号为' + existArr.join(',') + '的发票行已更新为最新录入数据',
            type: 'success',
            duration: 10000,
          });
        this.$emit('calTotal', true);
        this.checkDifferenceInvoice();
        this.$refs.xTable.updateFooter();
        this.$refs.creatDialog.defaultVisible = false;
        this.$refs.mcDialog.defaultVisible = false;
      },

      // 匹配委托加工合同
      selectMcContract(data) {
        console.log(123);
        let fullData = this.$refs.xTable.getTableData().fullData;
        let selectRecords = this.$refs.xTable.getCheckboxRecords();
        let selectIndex = fullData.findIndex((it) => it._XID == selectRecords[0]._XID);
        let isSetCheckRow = false; //优先填入本地勾选行，再新增插入行
        let existArr = [];
        data.map((it) => {
          // 存在已有入库单--入库单行ID+大类+小类 不重复
          let existConditon =
            it.inboundDetailId +
            '-' +
            selectRecords[0].expenseGroup +
            '-' +
            selectRecords[0].expenseType;
          let existIndex = fullData.findIndex((item) => {
            let fullDataItem =
              item.inboundDetailId + '-' + item.expenseGroup + '-' + item.expenseType;
            return fullDataItem == existConditon;
          });
          let row = { exchangeRate: selectRecords[0].exchangeRate };
          row['expenseGroup'] = selectRecords[0].expenseGroup;
          row['expenseType'] = selectRecords[0].expenseType;
          row['payableInvoiceDepartmentCode'] = selectRecords[0].payableInvoiceDepartmentCode;
          row['payableInvoiceDepartmentName'] = selectRecords[0].payableInvoiceDepartmentName;
          let matchInboundQuantity = it.matchInboundQuantity || 0;
          let businessVariablePriceWithoutTax = it.businessVariablePriceWithoutTax || 0;
          let invoiceQuantity = it.invoiceQuantity || 0;
          let invoiceUnitPrice = it.invoiceUnitPrice;
          let invoiceUnitPriceWithTax = it.invoiceUnitPriceWithTax;
          // let exchangeRate = it.exchangeRate || 0;
          row['invoiceUnit'] = it.productUnit; //单位
          row['matchInboundQuantity'] = matchInboundQuantity; //本次匹配入库数量
          row['inboundUnitPrice'] = businessVariablePriceWithoutTax; //入库单价
          row['inboundExchangeRate'] = 1; //入库汇率
          row['overShippedQuantity'] = 0; //益端装数量
          row['invoiceQuantity'] = invoiceQuantity; //本次收票数量
          row['inboundUnitPrice'] = this.$cal.calCommon(
            it.originalTotalWithoutTaxAmount,
            it.inboundQuantity,
            '/',
            'price'
          ); //入库单价
          // 只有成本采购货款时才需要计算暂估
          if (it.matchInboundQuantity == it.matchAvailableQuantity && it.matchAvailableAmount) {
            //本次匹配入库数量 == 可匹配数量 表示最后一次匹配采购合同  需要将入库单中的可匹配金额负值为暂估金额
            row['originProvisionalAmount'] = it.matchAvailableAmount;
            row['localProvisionalAmount'] = it.matchAvailableAmount;
            if (it.returnNo) {
              row['originProvisionalAmount'] = -it.matchAvailableAmount;
              row['localProvisionalAmount'] = -it.companyMatchAvailableAmount;
            }
          } else {
            //应付暂估原币金额=入库单价*本次收票数量
            row['originProvisionalAmount'] = this.$cal.calCommon(
              row.inboundUnitPrice,
              invoiceQuantity,
              '*',
              'amount'
            );
            row['localProvisionalAmount'] = this.$cal.calCommon(
              row['originProvisionalAmount'],
              row['inboundExchangeRate'],
              '*',
              'amount'
            ); //应付暂估本币金额=本次匹配入库数量*入库单价*入库汇率=应付暂估原币金额*入库汇率
          }
          row['invoiceUnitPrice'] = invoiceUnitPrice || 0; //发票单价
          row['invoiceUnitPriceWithTax'] = invoiceUnitPriceWithTax || 0; //发票含税单价
          row['productNo'] = it.productNo; //商品编码
          row['productDesc'] = it.productDesc; //商品描述
          row['inboundCode'] = it.inboundNo; //业务入库单号
          row['inboundDetailId'] = it.inboundDetailId; //业务入库单行号
          row['purchaseContractNo'] = it.contractNo; //采购合同号
          row['purchaseContractDetailNo'] = it.contractDetailNo; //采购合同行号
          row['inboundBatchNo'] = it.inboundBatchNo; //业务入库单批次号
          row['amountWithoutTax'] = it.originalTotalWithoutTaxAmount || 0; //本币不含税金额
          // 原币发票价差=（原币不含税金额-原币不含税暂估金额）
          const originInvoiceDifferPrice1 = this.$cal.calCommon(
            row['amountWithoutTax'],
            row['originProvisionalAmount'],
            '-',
            'amount'
          );
          row['originInvoiceDifferPrice'] = originInvoiceDifferPrice1;
          row['taxCode'] = it.taxCode; //税码
          row['taxRate'] = it.taxRate; //税率
          row['taxAmount'] = it.taxAmount || 0; //税额
          row['totalAmount'] = it.totalAmount; //总额
          //本币总额 = 总额*汇率
          row['domesticTotalAmount'] = this.$cal.calCommon(
            row['totalAmount'] || 0,
            row['exchangeRate'],
            '*',
            'amount'
          );
          // 本币不含税总额=总额*汇率
          row['domesticTotalWithoutTaxAmount'] = this.$cal.calCommon(
            it.originalTotalWithoutTaxAmount || 0,
            row['exchangeRate'],
            '*',
            'amount'
          );
          // 本币税额= 本币总额 - 本币不含税总额
          row['domesticTaxAmount'] = this.$cal.calCommon(
            row['domesticTotalAmount'],
            row['domesticTotalWithoutTaxAmount'],
            '-',
            'amount'
          );
          // 本币发票价差= 本币不含税金额-应付暂估本币金额
          row['localInvoiceDifferPrice'] = this.$cal.calCommon(
            row['domesticTotalWithoutTaxAmount'],
            row['localProvisionalAmount'],
            '-',
            'amount'
          );
          row = this.$baseRequest.assignObj(row);
          if (existIndex != -1) {
            // 存在已有入库单
            existArr.push(existIndex + 1);
            fullData[existIndex] = row;
            this.$refs.xTable.loadData(fullData);
            if (existIndex == selectIndex) isSetCheckRow = true;
          } else {
            if (isSetCheckRow) {
              this.$refs.xTable.insertAt(row);
            } else {
              fullData[selectIndex] = row;
              this.$refs.xTable.loadData(fullData);
              isSetCheckRow = true;
            }
          }
        });
        if (existArr.length > 0)
          this.$message({
            showClose: true,
            message: '行号为' + existArr.join(',') + '的发票行已更新为最新录入数据',
            type: 'success',
            duration: 10000,
          });
        this.$emit('calTotal', true);
        this.$refs.creatDialog.defaultVisible = false;
        this.$refs.mcDialog.defaultVisible = false;
      },

      // 禁止编辑
      filterDisabled(row, filed) {
        let result = false;
        // const arr  = ['amountWithoutTax', 'taxRate', 'taxAmount']
        const arr = ['taxRate'];
        if (arr.indexOf(filed) > -1) {
          result = row.inboundCode ? true : false;
        }
        return result;
      },
      // 校验获取值
      getVal() {
        return new Promise((resolve) => {
          let table = this.$refs.xTable.getTableData().fullData;
          console.log(table);
          this.$refs.xTable
            .validate()
            .then(() => {
              resolve(table);
            })
            .catch(() => {
              resolve(false);
            });
        });
      },
    },
  };
</script>
